import _ from "lodash";
import {
  FETCH_ORDERS
} from "../actions/types";

const INITIAL_STATE = {
  orders: []
};

export default (state = INITIAL_STATE, action) => {
  let orders, new_state;
  switch (action.type) {
    case FETCH_ORDERS:
      orders = [
        ...action.payload.data 
      ]
      new_state = {
        orders: orders
      } 
      return new_state
    default:
      return state;
  }
};
